import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { IGroupAction } from "src/app/interfaces/group-action";

@Injectable({
  providedIn: "root"
})
export class GroupRouteActionService {
  constructor(private core: CoreService) {}

  list(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.groupRouteAction.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  GetActionListByGroupId(gid: number): Observable<any> {
    return this.core.get(
      ServiceRoute.groupRouteAction.GetActionListByGroupId + gid,
      new CommonHttpOption().headers
    );
  }

  ListMenuForManagerUserAccess(): Observable<any> {
    return this.core.get(
      ServiceRoute.route.ListMenuForManagerUserAccess,
      new CommonHttpOption().headers
    );
  }

  saveActionListByGroupId(data: IGroupAction): Observable<any> {
    return this.core.post(
      ServiceRoute.groupRouteAction.saveActionListByGroupId,
      data,
      new CommonHttpOption().headers
    );
  }
}
